<template>
  <div>
    

        <a-form-model-item label="地域" prop="region_model">
          <a-radio-group :default-value="region_model" v-model="region_model" >
            <a-radio-button value=0>
              不限
            </a-radio-button>
            <a-radio-button value=1>
              地域
            </a-radio-button>
          </a-radio-group>


 



        </a-form-model-item>

        <a-form-model-item v-if="region_model == 1" label="" prop="region">
          <a-tree-select
            v-model="region"
            style="width: 100%"
            :tree-data="baiduRegion"
            tree-checkable
            :show-checked-strategy="SHOW_PARENT"
            search-placeholder="请选择地域"
            :dropdownStyle="{ maxHeight: '300px' }"
          />
          <!-- <m-region :selected="region" @select="selectRegion" datasource="prefecture" mergeChecked="upwards" /> -->
        </a-form-model-item>



        <a-form-model-item label="场所" prop="place_model">
          <a-radio-group :default-value="place_model" v-model="place_model" disabled>
            <a-radio-button value=0>
              不限
            </a-radio-button>
            <a-radio-button value=1>
              场所
            </a-radio-button>
          </a-radio-group>
        </a-form-model-item>

        <a-form-model-item v-if="place_model == 1" label="" prop="place">
          <m-places :place="place" @select="selectPlace" />
        </a-form-model-item>

        <a-form-model-item label="用户到访类型" prop="useractiontype" v-if="model.source_type!=2">
          <a-checkbox-group v-model="useractiontypeForm">
            <a-checkbox :value="item.id" v-for="item in userActionTypes" :key="item.id"> {{ item.name }}</a-checkbox>
          </a-checkbox-group>
        </a-form-model-item>


        <a-form-model-item label="年龄" prop="age">
          <byted-checkbox-group v-model="model.age" @change="singleChange($event, 'age')">
            <byted-checkbox-button :val="item.id" v-for="item in ages" :key="item.id" :single="item.id==0">{{ item.name }}</byted-checkbox-button>
          </byted-checkbox-group>
        </a-form-model-item>

        <a-form-model-item label="性别" prop="sex">
          <a-radio-group :default-value="sexForm" v-model="sexForm">
            <a-radio-button :value="item.id" v-for="item in sexs" :key="item.id">
              {{ item.name }}
            </a-radio-button>
          </a-radio-group>
        </a-form-model-item>

        <a-form-model-item label="人生阶段" prop="life_stage">
          <byted-checkbox-group v-model="model.life_stage" @change="singleChange($event, 'life_stage')">
            <byted-checkbox-button :val="item.id" v-for="item in LifeStages" :key="item.id" :single="item.id==0">{{ item.name }}</byted-checkbox-button>
          </byted-checkbox-group>
        </a-form-model-item>

        <a-form-model-item label="学历" prop="education">
          <byted-checkbox-group v-model="model.education" @change="singleChange($event, 'education')">
            <byted-checkbox-button :val="item.id" v-for="item in Education" :key="item.id" :single="item.id==0">{{ item.name }}</byted-checkbox-button>
          </byted-checkbox-group>
        </a-form-model-item>



        <a-form-model-item label="意图词" prop="keywords_model">
          <a-radio-group :default-value="keywords_model" v-model="keywords_model">
            <a-radio-button value=0>
              不限
            </a-radio-button>
            <a-radio-button value=1>
              任意意图词
            </a-radio-button>
          </a-radio-group>
        </a-form-model-item>

        <a-form-model-item v-if="keywords_model == 1" label="请在输入框内输入意图词" prop="place">
          <!-- <a-textarea v-model="keywords" placeholder="意图词" :auto-size="{ minRows: 15 }" @change="changeKeywords"/> -->
          <code-input ref="title_group" class="title-group" v-model="keywords" />
        </a-form-model-item>

        <a-form-model-item label="意图词用户行为" prop="keywords_extend">
          <byted-radio-group v-model="keywordsExtendForm">
            <byted-radio-button :val="item.id" v-for="item in keywordsExtend" :key="item.id">{{item.name}}</byted-radio-button>
          </byted-radio-group>
        </a-form-model-item>

        <a-form-model-item label="排除人群" prop="exclude_trans">
          <a-radio-group :default-value="excludeTransForm" v-model="excludeTransForm">
            <a-radio-button style="margin-top:5px" :value="item.id" v-for="item in ExcludeTrans" :key="item.id">
              {{ item.name }}
            </a-radio-button>
          </a-radio-group>
        </a-form-model-item>

        <a-form-model-item label="操作系统" prop="device">
          <byted-checkbox-group v-model="model.device" @change="singleChange($event, 'device')">
            <byted-checkbox-button :val="item.id" v-for="item in Devices" :key="item.id" :single="item.id==0">{{ item.name }}</byted-checkbox-button>
          </byted-checkbox-group>
        </a-form-model-item>

        <a-form-model-item v-if="model.device && model.device.indexOf(1) !== -1" label="IOS系统版本" prop="ios_version">
          <byted-checkbox-group v-model="model.ios_version" @change="singleChange($event, 'ios_version')">
            <byted-checkbox-button :val="item.id" v-for="item in IosVersion" :key="item.id" :single="item.id==0">{{ item.name }}</byted-checkbox-button>
          </byted-checkbox-group>

        </a-form-model-item>

        <a-form-model-item v-if="model.device && model.device.indexOf(2) !== -1" label="安卓手机品牌" prop="android_brands">
          <byted-checkbox-group v-model="model.android_brands" @change="singleChange($event, 'android_brands')">
            <byted-checkbox-button :val="item.id" v-for="item in AndroidBrands" :key="item.id" :single="item.id==0">{{ item.name }}</byted-checkbox-button>
          </byted-checkbox-group>
        </a-form-model-item>


        <a-form-model-item label="网络" prop="net">
          <a-radio-group :default-value="netForm" v-model="netForm">
            <a-radio-button :value="item.id" v-for="item in nets" :key="item.id">
              {{ item.name }}
            </a-radio-button>
          </a-radio-group>
        </a-form-model-item>

  </div>
</template>

<style lang="less" scoped>
@import 'AtpFeed';
</style>

<script>
import AtpFeed from './AtpFeed'

export default AtpFeed
</script>
